export class DealSignatureModel {
    signature: string;
    fileToUpload: File;
    isEmpty: boolean;
}


// WEBPACK FOOTER //
// ./src/app/_models/deal-signature.model.ts